/*----- AUTH users -------------------------------------------------------------------*/
export default {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  error: state => state.error,
  current_user: state => state.current_user,
  permissions: state => state.current_user.permissions
};
